import React from "react";
import {BrowserRouter} from "react-router-dom";
import "./App.scss";
import "./contexts/LoadingContext.scss";
import Main from "./containers/Main";
import {AuthProvider} from "./contexts/AuthContext";
import {SettingsProvider} from "./contexts/SettingsContext";
import {LoadingProvider} from "./contexts/LoadingContext";

function App() {
  return (
    <BrowserRouter>
      <LoadingProvider>
        <AuthProvider>
          <SettingsProvider>
            <div>
              <Main />
            </div>
          </SettingsProvider>
        </AuthProvider>
      </LoadingProvider>
    </BrowserRouter>
  );
}

export default App;
